// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Inter_516c7b', '__Inter_Fallback_516c7b'","fontStyle":"normal"},"className":"__className_516c7b"};